module.exports = __webpack_public_path__ + "static/media/advantageTitle.38447ee5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/advantageTitle.png
// module id = 1294
// module chunks = 0